import React from "react";
import HouseIcon from "@mui/icons-material/House";

//Types
import { SvgIconProps } from "@mui/material";

function POIIconKuca(props: SvgIconProps) {
  return <HouseIcon {...props}/>;
}

export default POIIconKuca;
